import React, { Component } from 'react';
import { Alert } from 'antd';
import Translate from 'react-translate-component';
import { propOr, omit } from 'ramda';

import { xmlFields } from 'constants/xmlDocumentTypes';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import ValidateCountField from './ValidateCountField';
import ValidateExistField from './ValidateExistField';

class XMLForm extends Component {
    componentWillUnmount() {
        const { form, values } = this.props;
        form.change('result', omit(['xmlbody'], propOr({}, 'result', values)));
    }

    render() {
        const { type } = this.props;
        const { event: { result } } = this.props;

        const Fields = xmlFields[type];

        return Fields ? (
            <div className="xml-form">
                <Fields {...this.props} />
                <ValidateCountField minSymbols={propOr(0, 'minSymbols', result)} />
            </div>
        ) : (
            <div>
                <Alert
                    message={<Translate content='events.formNotSet' />}
                    type='info'
                />
                <ValidateExistField />
            </div>
        );
    }
}

export default withAutoFocusForm(XMLForm);
